export const withProviders =
  (Component, ...Providers) =>
  (props) => {
    let toReturn = <Component {...props} />;
    Providers.forEach(
      (Provider) => (toReturn = <Provider>{toReturn}</Provider>)
    );
    return toReturn;
  };
